<template>
  <div :id="containerId" style="width: 100%;height: 100%;background-color: black;z-index: 0"></div>
</template>

<script>
import util from "@/util/util";

export default {
  name: "niiShow",
  props: {
    fileName: String,
    containerId: String
  },
  data() {
    return {
    }
  },
  mounted() {
    this.initPage();
  },
  methods: {
    initPage() {
      const r = new window.X.renderer3D();
      r.container = this.containerId;
      r.init();
      r.camera.position = [0, 400, 0];
      var volume = new window.X.volume();
      volume.file = util.baseUrl + this.fileName;
      r.add(volume)
      r.onShowtime = function () {
        const gui = new window.dat.GUI();
        // the following configures the gui for interacting with the X.volume
        var volumegui = gui.addFolder('Volume');
        // now we can configure controllers which..
        // .. switch between slicing and volume rendering
        this.vrController = volumegui.add(volume, 'volumeRendering');
        // the min and max color which define the linear gradient mapping
        this.minColorController = volumegui.addColor(volume, 'minColor');
        this.maxColorController = volumegui.addColor(volume, 'maxColor');
        // .. configure the volume rendering opacity
        this.opacityController = volumegui.add(volume, 'opacity', 0, 1).listen();
        // .. and the threshold in the min..max range
        this.lowerThresholdController = volumegui.add(volume, 'lowerThreshold',
            volume.min, volume.max);
        this.upperThresholdController = volumegui.add(volume, 'upperThreshold',
            volume.min, volume.max);
        this.lowerWindowController = volumegui.add(volume, 'windowLow', volume.min,
            volume.max);
        this.upperWindowController = volumegui.add(volume, 'windowHigh', volume.min,
            volume.max);
        // the indexX,Y,Z are the currently displayed slice indices in the range
        // 0..dimensions-1
        this.sliceXController = volumegui.add(volume, 'indexX', 0,
            volume.range[0] - 1);
        this.sliceYController = volumegui.add(volume, 'indexY', 0,
            volume.range[1] - 1);
        this.sliceZController = volumegui.add(volume, 'indexZ', 0,
            volume.range[2] - 1);
        volumegui.open();
      };
      r.render();
    }
  }
}
</script>

<style scoped>

</style>